import { c as _c } from "react/compiler-runtime";
import { getOrgApiKeysQueryKey, patchOrgApiKeysByIdMutation } from '@onefootprint/fetch-dashboard';
import type { DashboardSecretApiKey } from '@onefootprint/request-types/dashboard';
import { useMutation, useQueryClient } from '@tanstack/react-query';
const useUpdateStatus = apiKey => {
  const $ = _c(9);
  const queryClient = useQueryClient();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = patchOrgApiKeysByIdMutation();
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== queryClient) {
    t1 = {
      ...t0,
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: getOrgApiKeysQueryKey()
        });
      }
    };
    $[1] = queryClient;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const mutation = useMutation(t1);
  let t2;
  if ($[3] !== apiKey || $[4] !== mutation) {
    t2 = async () => {
      const newStatus = apiKey.status === "enabled" ? "disabled" : "enabled";
      await mutation.mutateAsync({
        path: {
          id: apiKey.id
        },
        body: {
          status: newStatus
        }
      });
    };
    $[3] = apiKey;
    $[4] = mutation;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const toggle = t2;
  let t3;
  if ($[6] !== mutation || $[7] !== toggle) {
    t3 = {
      toggle,
      mutation
    };
    $[6] = mutation;
    $[7] = toggle;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  return t3;
};
export default useUpdateStatus;